<template>
	<div v-if="promo" class="pdp-list-promo">
		<div class="list-promo">
			<div :class="styleClass">
				<div v-if="promoHeadline" class="lp-headline">
					{{ promoHeadline }}
				</div>
				<div class="lp-body">
					<span v-if="promoDescription">
						{{ promoDescription }}
					</span>
					<a
						class="lp-fp"
						@click="moreDetails"
						role="button"
						tabindex="0"
						@keydown.enter="moreDetails"
					>
						More Details
					</a>
				</div>
			</div>
		</div>

		<promo-detail-modal
			v-if="showPromoDetails"
			:promo="promo"
			:promo-headline="promoHeadline"
			:promo-description="promoDescription"
			@cancel="showPromoDetails=false"
		/>
	</div>
</template>

<script>
import PromoDetailModal from './PromoDetailModal.vue';
export default {
	name: 'PromoBox',
	props: {
		promo: Object
	},
	components: {
		PromoDetailModal
	},
	computed: {
		styleClass() {
			if (this.promo.isRewardsOffer) return 'lp-blue';
			return this.promo.styleClass ? this.promo.styleClass : 'lp-green';
		},
		promoHeadline() {
			if (this.promo.offerTitle && this.promo.pdpText) {
				return this.promo.offerTitle;
			} else if (this.promo.headline) {
				return this.promo.headline;
			} else if (this.promo.name) {
				return this.promo.name;
			} else if (this.promo.isRewardsOffer) {
				return "Blain's Rewards Offer";
			} else {
				return null;
			}
		},
		promoDescription() {
			if (!this.promo.pdpText && this.promo.offerTitle) {
				return this.promo.offerTitle;
			} else if (this.promo.pdpText) {
				return this.promo.pdpText;
			} else if (this.promo.text) {
				return this.promo.text;
			} else if (this.promo.description) {
				return this.promo.description;
			} else {
				return null;
			}
		},
	},
	data() {
		return {
			showPromoDetails: false,
		};
	},
	methods: {
		moreDetails() {
			this.showPromoDetails = true;
		}
	}
};
</script>

<style lang="less" scoped>
@import '../../less/_mixins.less';
.list-promo {
	max-width: 450px;
	.lp-body {
		line-height: 22px;
	}
}
.lp-fp {
	color: #014A77!important;
	font-weight: bold;
}
.lp-body {
	color: #666;
}
.pdp-list-promo {
	margin: 0 0 15px 20px;
}
@media screen and (max-width: @mobile-small) {
	.pdp-list-promo {
		margin: 7px 0 15px 0;
	}
	.list-promo {
		font-size: 12px;
	}
}
</style>